// extracted by mini-css-extract-plugin
export default {"page":"rU","heading":"sU","subheading":"tU","flavorbox":"uU","inner":"vU","image":"wU","label":"xU","flavorselect":"yU","arrow":"zU","flavorswrap":"AU","flavorsheader":"BU","flavorsnav":"CU","flavorsinner":"EU","cancelbtn":"FU","flavorsbottom":"GU","retakebtn":"HU","continueBtn":"IU","drawerinner":"JU","videowrap":"KU","flavorsbottomnav":"LU"};
    if(module.hot) {
      // 1711394579684
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  